import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MENUITEMS } from './Menu';
import { ChevronRight, Menu } from 'react-feather';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = window.innerWidth <= 768;

const user = JSON.parse(localStorage.getItem("user"));
const isAdmin = user?.isAdmin === true || user?.isAdmin === 1 || user?.isAdmin === "1";
console.log("👤 Logged in User:", user);
console.log("🔐 isAdmin:", isAdmin);
console.log("🧩 Raw MENUITEMS:", MENUITEMS);

// Filter MENUITEMS based on `permission: "admin"` where applicable
const filteredSections = MENUITEMS.map((section) => {
  const filteredItems = section.Items.filter((item) => {
    if (!item.permission) return true;
    if (item.permission === "admin") return isAdmin;
    return false;
  });

 const mappedItems = filteredItems.map((item) => {
  if (item.children) {
    const filteredChildren = item.children.filter((sub) => {
      if (!sub.permission) return true;
      return sub.permission === "admin" ? isAdmin : false;
    });

    return {
      ...item,
      children: filteredChildren
    };
  }
  return item;
});

  return {
    ...section,
    Items: mappedItems,
  };
});

const topLevelItems = filteredSections.flatMap(section => section.Items) || [];
console.log("📦 Filtered MENU Sections:", filteredSections);
console.log("📂 Top Level Items (after filtering):", topLevelItems);

  const [hoveredItem, setHoveredItem] = useState(null);
  const [submenuPosition, setSubmenuPosition] = useState({ top: 0 });
  const [subSubmenuPosition, setSubSubmenuPosition] = useState({ top: 0 });
  const [activeSubItem, setActiveSubItem] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);

  const [mobileSubIndex, setMobileSubIndex] = useState(null);
  const [mobileSubSubIndex, setMobileSubSubIndex] = useState(null);

  const itemRefs = useRef([]);
  const submenuItemRefs = useRef([]);
  const hoverTimeoutRef = useRef(null);
  const subHoverTimeoutRef = useRef(null);

  const handleNavigation = (item) => {
    if (item.type === 'blank') window.open(item.path, '_blank');
    else {
      navigate(item.path);
      if (isMobile) setIsSidebarOpen(false);
    }
  };

  const getSafeTop = (elementRect, estimatedHeight = 300) => {
    let top = elementRect.top;
    if (top + estimatedHeight > window.innerHeight) {
      top = window.innerHeight - estimatedHeight - 10;
    }
    if (top < 0) top = 10;
    return top;
  };

  const handleMouseEnter = (index) => {
    if (isMobile) return;
    clearTimeout(hoverTimeoutRef.current);
    const ref = itemRefs.current[index];
    if (ref) {
      const rect = ref.getBoundingClientRect();
      setSubmenuPosition({ top: getSafeTop(rect) });
    }
    if (hoveredItem !== index) {
      setHoveredItem(index);
      setActiveSubItem(null);
    }
  };

  const handleSubItemHover = (cIndex) => {
    if (isMobile) return;
    clearTimeout(subHoverTimeoutRef.current);
    const ref = submenuItemRefs.current[cIndex];
    if (ref) {
      const rect = ref.getBoundingClientRect();
      setSubSubmenuPosition({ top: getSafeTop(rect) });
    }
    setActiveSubItem(cIndex);
  };

  const sidebarStyles = {
    backgroundColor: '#0062ff',
    width: isSidebarOpen ? (isMobile ? '240px' : '100px') : '0',
    height: '100vh',
    display: isSidebarOpen ? 'flex' : 'none',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    overflow: 'hidden',
    zIndex: 100,
    transition: 'width 0.3s ease',
  };


  const menuScrollStyles = {
    width: '100%',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  };

  const sidebarItemStyles = {
    color: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '10px 0',
    fontSize: '10px',
    cursor: 'pointer',
    textAlign: 'center',
    width: '100%',
    padding: '6px 0',
    position: 'relative',
  };

  const iconWrapperStyles = {
    padding: '4px',
    borderRadius: '10px',
    transition: 'all 0.2s',
  };

  const labelStyles = {
    fontSize: '11px',
    marginTop: '4px',
    padding: '0 6px',
    wordBreak: 'break-word',
  };

  const popoutStyles = (top, left = 100) => ({
    position: 'fixed',
    background: '#0250d9',
    color: '#fff',
    width: '240px',
    left,
    top,
    maxHeight: '300px',
    overflowY: 'auto',
    zIndex: 9999,
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  });

  const submenuItemStyles = {
    padding: '10px 15px',
    color: '#fff',
    fontSize: '13px',
    cursor: 'pointer',
    position: 'relative',
    transition: 'background-color 0.2s',
  };

  const arrowIconStyles = {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* Toggle button for mobile */}
      {isMobile && (
        <div style={{ position: 'fixed', top: 10, left: 10, zIndex: 101 }}>
          <Menu
            color={isSidebarOpen ? '#fff' : '#000'}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          />
        </div>
      )}

      <div style={sidebarStyles}>
        <style>
          {`
            .menu-scroll::-webkit-scrollbar {
              width: 0px;
              background: transparent;
            }
            .menu-scroll {
              scrollbar-width: thin;
              scrollbar-color: transparent transparent;
            }
          `}
        </style>

        <div style={menuScrollStyles} className="menu-scroll">
          {topLevelItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            const hasChildren = item.type === 'sub' && Array.isArray(item.children);

            return (
              <div key={index}>
                <div
                  ref={(el) => (itemRefs.current[index] = el)}
                  style={sidebarItemStyles}
                  onClick={() => {
                    if (!hasChildren) {
                      handleNavigation(item);
                    } else if (isMobile) {
                      setMobileSubIndex(mobileSubIndex === index ? null : index);
                      setMobileSubSubIndex(null);
                    }
                  }}
                  onMouseEnter={() => handleMouseEnter(index)}
                >
                  <div
                    style={{
                      ...iconWrapperStyles,
                      ...(isActive || hoveredItem === index
                        ? {
                          border: '2px solid #fff',
                          backgroundColor: 'var(--color-secondary)',
                        }
                        : {}),
                    }}
                  >
                    <Icon size={24} />
                  </div>
                  <span style={labelStyles}>{item.title}</span>
                </div>

                {/* MOBILE: SUB MENU */}
                {
                  isMobile && mobileSubIndex === index && hasChildren && (
                    <div style={{ width: '100%', paddingLeft: 10 }}>
                      {item.children.map((sub, subIndex) => {
                        const hasSubSub = Array.isArray(sub.children);
                        return (
                          <div key={subIndex}>
                            <div
                              style={{
                                padding: '8px 0',
                                paddingLeft: 10,
                                fontSize: '12px',
                                color: '#fff',
                                cursor: 'pointer',
                                borderBottom: '1px solid var(--color-primary)',
                              }}
                              onClick={() => {
                                if (hasSubSub) {
                                  setMobileSubSubIndex(
                                    mobileSubSubIndex === subIndex ? null : subIndex
                                  );
                                } else {
                                  handleNavigation(sub);
                                }
                              }}
                            >
                              {sub.title}
                            </div>

                            {/* MOBILE: SUBSUB MENU */}
                            {
                              hasSubSub && mobileSubSubIndex === subIndex && (
                                <div style={{ paddingLeft: 20 }}>
                                  {sub.children.map((subsub, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        padding: '6px 0',
                                        fontSize: '11px',
                                        color: '#ccc',
                                        cursor: 'pointer',
                                        borderBottom: '1px dashed var(--color-primary)',
                                      }}
                                      onClick={() => handleNavigation(subsub)}
                                    >
                                      {subsub.title}
                                    </div>
                                  ))}
                                </div>
                              )
                            }
                          </div>
                        );
                      })}
                    </div>
                  )
                }
              </div>
            );
          })}
        </div>

        {/* DESKTOP ONLY: Popout SUB/SUBSUB */}
        {!isMobile && hoveredItem !== null && (
          <div
            onMouseEnter={() => {
              clearTimeout(hoverTimeoutRef.current);
              clearTimeout(subHoverTimeoutRef.current);
            }}
            onMouseLeave={() => {
              hoverTimeoutRef.current = setTimeout(() => {
                setHoveredItem(null);
                setActiveSubItem(null);
              }, 200);
            }}
            style={{ position: 'absolute', left: '100px', display: 'flex', zIndex: 9999 }}
          >
            {/* SUB MENU */}
            <div style={popoutStyles(submenuPosition.top, 100)}>
              {Array.isArray(topLevelItems[hoveredItem]?.children) &&
                topLevelItems[hoveredItem].children.map((child, cIndex) => {
                  const hasSubSub = Array.isArray(child.children);
                  const isActive = activeSubItem === cIndex;
                  return (
                    <div
                      key={cIndex}
                      ref={(el) => (submenuItemRefs.current[cIndex] = el)}
                      style={{
                        ...submenuItemStyles,
                        ...(isActive ? { background: 'var(--color-secondary)' } : {}),
                      }}
                      onMouseEnter={() => hasSubSub && handleSubItemHover(cIndex)}
                      onClick={() => {
                        if (!hasSubSub) {
                          setHoveredItem(null);
                          setActiveSubItem(null);
                          handleNavigation(child);
                        }
                      }}
                    >
                      {child.title}
                      {hasSubSub && <ChevronRight size={12} style={arrowIconStyles} />}
                    </div>
                  );
                })}
            </div>

            {/* SUBSUB MENU */}
            {activeSubItem !== null &&
              Array.isArray(topLevelItems[hoveredItem]?.children) &&
              Array.isArray(topLevelItems[hoveredItem].children[activeSubItem]?.children) && (

                <div style={popoutStyles(subSubmenuPosition.top, 260)}>
                  {topLevelItems[hoveredItem].children[activeSubItem].children.map((subChild, i) => (
                    <div
                      key={i}
                      style={submenuItemStyles}
                      onClick={() => {
                        setHoveredItem(null);
                        setActiveSubItem(null);
                        handleNavigation(subChild);
                      }}
                    >
                      {subChild.title}
                    </div>
                  ))}
                </div>
              )}
          </div>
        )}
      </div >
    </>
  );
};

export default Sidebar;
